export const SEND_RESULT_RATING_MAIL_SUCCESS = 'SEND_RESULT_RATING_MAIL_SUCCESS';

export const sendResultRatingMailSuccess = ({ allowToSendMail }) => ({
    type: SEND_RESULT_RATING_MAIL_SUCCESS,
    payload: {
        allowToSendMail,
    }
});
